var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_21854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3083 5.97472V9.10432L32.4209 5.80192L40.0333 13.9667V10.8419L32.5709 2.24512L19.3083 5.97472Z",
    fill: "#AA2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.68773 11.5327L9.88356 9.0127L19.3794 15.2623L32.4961 12.4831L40.1836 18.9967V22.0351L32.4211 16.3039L19.3044 18.8239L9.5794 12.3103L0.83773 14.3935C0.83773 14.3935 0.61273 11.5279 0.68773 11.5279V11.5327Z",
    fill: "#AA2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.612305 19.0882V22.0402L9.58314 20.4754L19.3081 27.8578L32.2706 26.9026L40.2623 29.7682V26.7298L32.5706 22.909L19.3831 24.6466L9.80814 17.3506L0.612305 19.0882Z",
    fill: "#AA2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.538086 26.902V29.6812L9.65892 28.9852L19.1548 37.4092H32.9506L40.0339 37.4956V34.4572L32.5714 33.3292L19.4589 34.1116L9.58392 26.0332L0.538086 26.902Z",
    fill: "#AA2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.462717 34.3711H9.65855V37.7599H0.612717C0.612717 37.7599 0.275217 34.5919 0.462717 34.3711Z",
    fill: "#AA2000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_21854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/Work.68fe43c918fb5cab52082125abc69c0a.svg";
export { ForwardRef as ReactComponent };